import { toast as toastLib } from 'react-toastify';

const toast = (message: string) => {
  toastLib.dark(message, {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};

export default toast;
